import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Contatti = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        
        <div className="text-center mb-8 md:mb-12">
          <h1 className="text-2xl md:text-4xl font-bold text-white mb-4">
            {t('pages.contact.title')}
          </h1>
          <p className="text-gray-400 text-sm md:text-base max-w-2xl mx-auto">
            {t('pages.contact.subtitle')}
          </p>
        </div>

        <div className="space-y-8">
          
          <div className="bg-black rounded-xl p-6 md:p-8">
            <h2 className="text-xl md:text-2xl font-semibold text-white mb-6">{t('pages.contact.company_name')}</h2>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <h3 className="text-white font-medium mb-2">{t('pages.contact.address')}</h3>
                  <p className="text-gray-300 text-sm md:text-base whitespace-pre-line">
                    {t('pages.contact.address_text')}
                  </p>
                </div>
                
                <div>
                  <h3 className="text-white font-medium mb-2">{t('pages.contact.fiscal_data')}</h3>
                  <p className="text-gray-300 text-sm md:text-base">
                    {t('pages.contact.vat')}
                  </p>
                </div>
                
                <div>
                  <h3 className="text-white font-medium mb-2">{t('pages.contact.email')}</h3>
                  <a 
                    href="mailto:lamonilabsrl@gmail.com" 
                    className="text-blue-400 hover:text-blue-300 transition-colors duration-150 text-sm md:text-base"
                  >
                    lamonilabsrl@gmail.com
                  </a>
                </div>
              </div>
              
              <div className="space-y-4">
                <div>
                  <h3 className="text-white font-medium mb-2">{t('pages.contact.company_social')}</h3>
                  <p className="text-gray-300 text-sm md:text-base">
                    {t('pages.contact.company_social_text')}
                  </p>
                </div>
                
                <div>
                  <h3 className="text-white font-medium mb-2">{t('pages.contact.sector')}</h3>
                  <p className="text-gray-300 text-sm md:text-base">
                    {t('pages.contact.sector_text')}
                  </p>
                </div>
                
                <div>
                  <h3 className="text-white font-medium mb-2">{t('pages.contact.city')}</h3>
                  <p className="text-gray-300 text-sm md:text-base">
                    {t('pages.contact.city_text')}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-black rounded-xl p-6 md:p-8">
            <h2 className="text-xl md:text-2xl font-semibold text-white mb-6">{t('pages.contact.location_title')}</h2>
            
            <div className="space-y-4">
              <p className="text-gray-300 text-sm md:text-base">
                {t('pages.contact.location_desc')}
              </p>
              
              <div className="rounded-lg overflow-hidden border border-gray-700">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2968.8847434706354!2d12.595833176544385!3d41.96598797122124!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132f61b6532013ad%3A0x5f8b8d4d0d2b8c6a!2sVia%20Osteria%20del%20Finocchio%2C%2037%2C%2000132%20Roma%20RM%2C%20Italy!5e0!3m2!1sen!2sus!4v1692805200000!5m2!1sen!2sus"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Lamoni Lab Location"
                  className="w-full h-64 md:h-96"
                />
              </div>
              
              <p className="text-gray-400 text-xs md:text-sm text-center">
                {t('pages.contact.map_caption')}
              </p>
            </div>
          </div>

          <div className="bg-black rounded-xl p-6 md:p-8">
            <h2 className="text-xl md:text-2xl font-semibold text-white mb-6">{t('pages.contact.contact_form_title')}</h2>
            
            <div className="max-w-2xl">
              <p className="text-gray-300 text-sm md:text-base mb-6">
                {t('pages.contact.contact_form_desc')}
              </p>
              
              <a 
                href="mailto:lamonilabsrl@gmail.com?subject=Richiesta informazioni BeautyKit"
                className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-150"
              >
                {t('pages.contact.send_email')}
              </a>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default Contatti;
